import * as React from 'react';
import { useMutation } from 'redux-query-react';
import { useDispatch } from 'react-redux';
import licenceRequest from 'data/carSearch/LicenceRequest';
import { setSelectedVehicleInStore } from 'data/selectedVehicle/selectedVehicleHandler';
import { ISavedVehicle, resolveSavedVehicle } from 'components/SearchBlock/CarSearch/SelectCar/savedVehicle';

export interface IVehicleSearchProps {
    config: {
        searchUrl: string;
        linkText: string;
        vehicle: ISavedVehicle;
    };
}

// "Select and search" on the account "My cars" page. Re-fetches the chosen car's full details by its
// stored plate (so the remembered car carries year/power/engine code/next inspection, same as a plate
// search), remembers it, then navigates to its parts results page. The anchor keeps a real href, so it
// still works (just without the enrich) if this script hasn't loaded.
const VehicleSearch: React.FunctionComponent<IVehicleSearchProps> = ({ config }) => {
    const { searchUrl, linkText, vehicle } = config;
    const dispatch = useDispatch();
    const [{ isPending }, queryLicence] = useMutation((licence: string) => licenceRequest(licence));

    const selectAndSearch = async (e: React.MouseEvent) => {
        e.preventDefault();
        if (isPending) {
            return;
        }
        const resolved = await resolveSavedVehicle(vehicle, queryLicence);
        dispatch(setSelectedVehicleInStore(resolved));
        window.location.href = searchUrl;
    };

    return <span onClick={selectAndSearch}>{linkText}</span>;
};

VehicleSearch.displayName = 'Vehicle search';

export default VehicleSearch;
